<template>
  <div class="row spinner-parent">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h1>Edit quiz question</h1>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block spinner-parent">
                <spinner ref="spinner" size="md" text="Loading ..." />
                <div class="form-group row">
                  <label for="title" class="col-md-2">Question *</label>
                  <div class="col-md-10">
                    <input
                      id="title"
                      v-model="entity.question"
                      type="text"
                      placeholder="Enter question"
                      class="form-control"
                    >
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-md-2" for="default">Answer *</label>
                  <div class="col-md-10">
                    <select id="default" v-model="entity.answer" class="form-control">
                      <option :value="true">
                        True
                      </option>
                      <option :value="false">
                        False
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="bio" class="col-md-2">Explanation</label>
                  <div class="col-md-10">
                    <textarea
                      id="title"
                      v-model="entity.explanation"
                      type="text"
                      placeholder="Enter explanation"
                      class="form-control"
                    ></textarea>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="bio" class="col-md-2">More Info Text</label>
                  <div class="col-md-10">
                    <input
                      id="title"
                      v-model="entity.more_info"
                      type="text"
                      placeholder="Enter text"
                      class="form-control"
                    >
                  </div>
                </div>
                <div class="form-group row">
                  <label for="bio" class="col-md-2">More Info Link</label>
                  <div class="col-md-10">
                    <input
                      id="title"
                      v-model="entity.link"
                      type="text"
                      placeholder="Enter link"
                      class="form-control"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-5">
        <button class="btn btn-success" @click="save">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Quiz question updated successfully!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div><!--/.row-->
</template>

<script>
import _ from 'lodash';
// Mixins
import CreatePageMixin from '@/mixins/CreatePageMixin';
import DefaultOptionsRequests from '@/mixins/DefaultOptionsRequests';
import QuizGameMixin from '@/mixins/QuizGameMixin';

export default {
  name: 'QuizImagesEdit',

  mixins: [CreatePageMixin, DefaultOptionsRequests, QuizGameMixin],

  mounted() {
    this.getSource();
  },

  methods: {
    saveRequest() {
      const postFormData = new FormData();
      postFormData.append('question', this.entity.question);
      if (this.entity.answer) {
        postFormData.append('answer', 1)
      } else {
        postFormData.append('answer', 0)
      };
      if (this.entity.explanation) {
        postFormData.append('explanation', this.entity.explanation);
      };
      if (this.entity.more_info) {
        postFormData.append('more_info', this.entity.more_info);
      };
      if (this.entity.link) {
        postFormData.append('link', this.entity.link);
      };
      return this.$apiHttp.post(`${this.$config.app_api.prefix}games/quiz/${this.$route.params.id}`, postFormData);
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      this.saveRequest().then(() => {
        this.$_successSave();
        this.$parent.getSource();
      }, (error) => {
        console.error('Error in audio create request', error);
        this.$_errorSave(error);
      });
    },
    getSource() {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      const formData = new FormData();
      formData.append('with[]', 'image');
      this.$apiHttp.get(`${this.$config.app_api.prefix}games/quiz/${this.$route.params.id}`)
        .then((response) => {
          const source = _.cloneDeep(response.data);
          const clone = _.cloneDeep(source);
          this.source = source;
          this.entity = clone;
          if (!this.images.length) {
            return this.getAllImages();
          }
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
          return null;
        })
        .then((response) => {
          if (!response) {
            return;
          }
          const memoryImages = _.cloneDeep(response.data);
          delete memoryImages.meta;
          const images = Object.keys(memoryImages).map(e => memoryImages[e]);
          this.$store.dispatch('quizGame/setImages', images);
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
        })
        .catch((error) => {
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
          this.$store.dispatch('notifications/setHttpError', { error, text: 'Error in getting puzzle image request' });
          console.error('Error in get single document files query', error);
        });
    },
    getAllImages() {
      return this.$apiHttp.get(`${this.$config.app_api.prefix}games/quiz`, {
        params: {
          nonpaginated: true,
        },
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// Edit.vue?20c18505